import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const OpenPanesDropdown = ({ openPanes = [], activePaneType, onSwitch }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  if (openPanes.length < 2) return null;

  const anyDirty = openPanes.some((p) => p.isDirty);

  return (
    <>
      <Button
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
        endIcon={<KeyboardArrowDownIcon sx={{ fontSize: '14px !important' }} />}
        sx={{
          color: 'white',
          mr: 0.5,
          minWidth: 0,
          px: 1,
          py: 0.5,
          fontSize: '0.72rem',
          fontWeight: 700,
          lineHeight: 1,
          backgroundColor: 'rgba(255,255,255,0.18)',
          borderRadius: 1,
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.28)' },
          textTransform: 'none',
        }}
      >
        {openPanes.length}{anyDirty ? '*' : ''}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ sx: { minWidth: 220 } }}
      >
        {openPanes.map((pane) => (
          <MenuItem
            key={pane.type}
            selected={pane.type === activePaneType}
            onClick={() => {
              onSwitch(pane.type);
              setAnchorEl(null);
            }}
            sx={{ gap: 1 }}
          >
            {pane.isDirty ? (
              <FiberManualRecordIcon sx={{ fontSize: 8, color: 'warning.main', flexShrink: 0 }} />
            ) : (
              <Box sx={{ width: 8, flexShrink: 0 }} />
            )}
            <Typography
              variant="body2"
              sx={{ fontWeight: pane.type === activePaneType ? 700 : 400 }}
            >
              {pane.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default OpenPanesDropdown;
